<div class="circular-progress">
    <svg class="progress-ring" [attr.width]="size" [attr.height]="size">
        <circle
            class="progress-ring__circle-bg"
            [attr.stroke]="backgroundColor"
            [attr.stroke-width]="strokeWidth"
            fill="transparent"
            [attr.r]="radius"
            [attr.cx]="center"
            [attr.cy]="center"
        />
        <circle
            class="progress-ring__circle"
            [attr.stroke-dasharray]="circumference + ' ' + circumference"
            [attr.stroke-dashoffset]="strokeDashoffset"
            [attr.stroke]="strokeColor"
            [attr.stroke-width]="strokeWidth"
            fill="transparent"
            [attr.r]="radius"
            [attr.cx]="center"
            [attr.cy]="center"
            stroke-linecap="round"
            [style.animation-duration]="animationDuration + 's'"
        />
    </svg>
    <div class="progress-text">
        <span class="progress-value">{{ displayValue }}</span>
        <span class="progress-label" *ngIf="label">{{ label }}</span>
    </div>
</div>
